import React, {useState, useEffect, useCallback} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import Parser from 'html-react-parser';
import {
    checkFavoriteItem,
    delFavoriteItem,
    updateItemGroup,
    updateItemQuantity,
    addToCart,
} from '../actions/FavoriteAppActions';
import {NLoader} from './NLoader';
import debounceFunc from '../utils/debounce';
import formattedPrice from '../utils/formattedPrice';


const FavoriteProduct  = props => {

    const default_group = "Избранное"
    const {item, groups, index, checkFavoriteItem, delFavoriteItem, updateItemQuantity, updateItemGroup, addToCart} = props;
    const extra_price_default = item.total === item.subtotal ? 0 : item.subtotal;
    const extra_price = !item.checked ? item.total: extra_price_default;
    const real_step = item.unit_step ? parseFloat(item.unit_step): 1.0;
    const real_quantity = item.quantity * real_step;

    const [isFetching, setFetching] = useState(false);
    const [quantityValue, setQuantityValue] = useState(real_quantity);
    const [groupEditMode, setGroupEditMode] = useState("");
    const [groupAddName, setGroupAddName] = useState(item.group);

    const plus_enabled = (isFetching || !item.checked) ? false : true; //|| (item.quantity >= item.summary.max_quantity)
    const minus_enabled = (isFetching || !item.checked || (item.quantity === 1)) ? false : true;
    const quantity_enabled = isFetching || !item.checked ? false : true;

    const no_img = "/static/shop_backbone/images/noimage.png";

    const updateQuantity = (item, quantity) => {
        setFetching(true);
        updateItemQuantity(item, quantity);
    };

    const debounceUpdateQuantity = useCallback(
        debounceFunc(updateQuantity, 600)
    , []);

    const handleRemove = (e, item_id) => {
        setFetching(true);
        delFavoriteItem(item_id);
        e.preventDefault();
    };

    const handleChangeChecked = e => {
        setFetching(true);
        checkFavoriteItem(item.id, !item.checked);
        e.preventDefault();
    };

    const handleEditGroup = (e, mode) => {
        setGroupEditMode(mode);
        e.preventDefault();
    };

    const handleSetAddGroupName = (e, name) => {
        setGroupAddName(name);
        e.preventDefault();
    };

    const handleAplayGroupName = (e) => {
        if(groupAddName!==item.group){
            setFetching(true);
            updateItemGroup(item, groupAddName);
        }
        setGroupEditMode("");
        e.preventDefault();
    };

    const handleSelectGroupName = (e, name) => {

        if(name !== item.group){
            let new_name = name === default_group ? "" : name;
            setFetching(true);
            updateItemGroup(item, new_name);
            setGroupAddName(new_name);
        }
        setGroupEditMode("");
        e.preventDefault();
    };

    const handleCancelGroupName = (e) => {
        setGroupEditMode("");
        setGroupAddName(item.group);
        e.preventDefault();
    };

    const handleDeltaQuantity = (e, delta) => {

        let c_quantity = prepareQuantity(quantityValue) + delta;
        let c_real_quantity =  real_step * c_quantity;

        if (delta > 0){
            // increment
            debounceUpdateQuantity(item, c_quantity);
            setQuantityValue(c_real_quantity);
        }else if (c_quantity >= 1){
            debounceUpdateQuantity(item, c_quantity);
            setQuantityValue(c_real_quantity);
        }
    };

    const prepareQuantity = quantity => {

        let unit_step = item.unit_step ? parseFloat(item.unit_step): 1.0;
        let result = unit_step;
        quantity = quantity ? quantity: unit_step;

        if (unit_step===1.0){
            result = parseInt(quantity);
        }else{
            result = Math.trunc(parseFloat(quantity) / unit_step);
        }

        return result
    };

    const handleChangeQuantity = real_quantity => {

        if (real_quantity.includes(",")){
            real_quantity = real_quantity.replace(",", ".")
        }
        setQuantityValue(parseFloat(real_quantity)||'');
    };

    const handleAplayQuantity = e => {

        let c_quantity = prepareQuantity(quantityValue);
        let unit_step = item.unit_step ? parseFloat(item.unit_step): 1.0;

        if (c_quantity < 1 ){
            c_quantity = 1;
        }
        let c_real_quantity =  unit_step * c_quantity;

        if (c_real_quantity.toString() !== quantityValue.toString()){
            setQuantityValue(c_real_quantity);
        }

        if (c_quantity !== item.quantity){
            setFetching(true);
            updateItemQuantity(item, c_quantity);
        }

    };

    const handleAddToCart = e => {
        addToCart(item);
        e.preventDefault();
    };

    useEffect(() => {
        let new_quantity = real_step * item.quantity
        setQuantityValue(new_quantity);
        setFetching(false);

    }, [item.updated_at]);

    const renderEditGroup = () => {
        return (<>
            {groupEditMode === "add" ?
                <>
                    <input type="text"
                           maxLength={100}
                           className="ncart-form-control add-group"
                           value={groupAddName}
                           onChange={e => handleSetAddGroupName(e, e.currentTarget.value)}
                           onKeyDown={e => e.key === 'Enter' && handleAplayGroupName(e)}
                    />
                    <i className="material-icons fav-edit-icon text-success mx-1"
                       onClick={e => handleAplayGroupName(e)}>check
                    </i>
                    <i className="material-icons fav-edit-icon text-danger mx-1"
                       onClick={e => handleCancelGroupName(e)}>cancel
                    </i>
                </>
                :
                null
            }
            {groupEditMode === "select" ?
                <>
                    <span className="group-value dropdown-toggle show align-middle"
                          type="button"
                          aria-expanded="true"
                          onClick={e => handleEditGroup(e, "select")}>
                        {item.group.length > 0 ? item.group : default_group}
                    </span>
                    <ul className="dropdown-menu show" tabIndex={0} aria-selected={true}>
                        <li>
                            <a className="dropdown-item"
                               onClick={e => handleSelectGroupName(e, default_group)}
                               href="#">
                                {default_group}
                            </a>
                        </li>
                        <li><hr className="dropdown-divider"/></li>
                        {groups.map((group_var, g_key) => (
                            <li key={g_key}>
                                <a className="dropdown-item"
                                   href="#"
                                   onClick={e => handleSelectGroupName(e, group_var)}>
                                    {group_var}
                                </a>
                            </li>
                        ))}
                    </ul>
                </>
                :
                null
                }
            </>
        )
    }
    const renderGroup = () => {
        return (
            <>
                {item.group.length > 0 ?
                    <span className="group-value dropdown-toggle align-middle"
                          type="button"
                          aria-expanded="false"
                          onClick={e => handleEditGroup(e, "select")}>
                        {item.group}
                    </span>
                    :
                    <span className={'group-value align-middle'}> {default_group}</span>
                }
                <span className="group-control align-middle">
                    {groups.length > 0 ?
                        <i className="material-icons fav-edit-icon align-middle"
                           onClick={e => handleEditGroup(e, "select")}>
                            arrow_drop_down
                        </i>
                        :
                        null
                    }
                    <i className="material-icons fav-edit-icon align-middle text-success"
                        onClick={e => handleEditGroup(e, "add")}>
                        add
                    </i>
                </span>
            </>)
    }

    return (
        <>
            <div key={'h'+index} className={'row'}>
                <div className="col-2">
                    <div className="ncart-checked-button">
                        <input type="checkbox" id={`ncart-product-check-${index}`}
                               className={`ncart-checkbox filled-in${item.summary.enabled ? '' : ' error-text'}`}
                               checked={item.checked ? 1 : 0}
                               onChange={e => handleChangeChecked(e)}/>
                        <label htmlFor={`ncart-product-check-${index}`}></label>
                    </div>
                </div>
                <div className="col-8">
                    <span className={'group-title ncart-art-heading me-1 align-middle'}>
                        Список:
                    </span>
                    { groupEditMode.length > 0 ? renderEditGroup() : renderGroup()}
                </div>
                <div className="col-2">
                    <span className="delete-control align-middle" onClick={e => handleRemove(e, item.id)}>
                      <i className="material-icons">
                          close
                      </i>
                  </span>
                </div>
            </div>
            <div className={`row ncart-product${item.checked ? '' : ' product-disabled'}`} key={index}>
                <div className="col-sm-2 col-4">
                    <div className="ncart-image">
                        <a href={item.summary.link ? item.summary.link : '#'}>
                            <img className="img-responsive" src={item.image ? item.image : no_img}/>
                        </a>
                    </div>
                </div>
                <div className="col-sm-5 col-lg-6 col-xs-9 order-last order-sm-0">
                    { item.summary.enabled_help_text &&
                      <h4 className="ncart-item-heading">
                          <span className="ncart-art-heading error-text">Внимание! {item.summary.enabled_help_text}</span>
                      </h4>
                    }
                    <h4 className="ncart-item-heading">
                        <span className="ncart-art-heading">Артикул: </span> <span>{item.summary.art}</span>
                        {item.extra_rows && item.extra_rows.map((extra_row, e_index) => (
                            <span className="ncart-discount-heading"
                                  key={e_index}>
                                {extra_row.title}
                                <span>({extra_row.amount}&nbsp;&#8381;)</span>
                            </span>
                        ))}
                    </h4>
                    <h4 className={`ncart-item-title${item.summary.enabled ? '': ' error-text'}`}>
                        <a href={item.summary.link ? item.summary.link : '#'}>{item.title}</a>
                    </h4>
                    <div className="ncart-item-description">
                        {Parser(item.summary.html)}
                    </div>
                </div>
                <div className="col-8 col-sm-3">
                    <div className="ncart-extra-price">
                        <span className="ncart-extra-price-padding">&nbsp;</span>
                        { extra_price ?
                            <span className="ncart-extra-price-value">
                                { formattedPrice(extra_price) }&nbsp;&#8381;
                            </span>
                            :
                            <span className="noline"></span>
                        }
                    </div>
                    <div className="ncart-item-price">
                        {isFetching ?
                            <NLoader/>
                            :
                            <span className={`price${item.summary.enabled ? '': ' error-text'}`}>
                                {item.checked ? formattedPrice(item.total) : 0}&nbsp;&#8381;
                            </span>
                        }
                    </div>
                    <div className="ncart-item-quantity">
                        {minus_enabled ?
                            <div className="nquantity-control nquantity-down"
                                 onClick={e => handleDeltaQuantity(e, -1)}>
                                <i className="material-icons">remove</i>
                            </div>
                            :
                            <div className="nquantity-control nquantity-down disabled">
                                <i className="material-icons">remove</i>
                            </div>
                        }
                        {quantity_enabled ?
                            <div className="ncart-form-line">
                                <input type="text"
                                       className={`ncart-form-control${item.summary.enabled ? '': ' error-text'}`}
                                       onBlur={e => handleAplayQuantity(e)}
                                       onChange={e => handleChangeQuantity(e.currentTarget.value)}
                                       onKeyDown={e => e.key === 'Enter' && handleAplayQuantity(e)}
                                       value={quantityValue}/>
                            </div>
                            :
                            <div className="ncart-form-line">
                                <input type="text"
                                       className="ncart-form-control disabled"
                                       value={quantityValue}
                                       readOnly={true}/>
                            </div>
                        }
                        {plus_enabled ?
                            <div className="nquantity-control nquantity-up"
                                 onClick={e => handleDeltaQuantity(e, 1)}>
                                <i className="material-icons">add</i>
                            </div>
                            :
                            <div className="nquantity-control nquantity-up disabled">
                                <i className="material-icons">add</i>
                            </div>
                        }
                    </div>
                    <div className="ncart-item-unit">{item.unit}</div>
                </div>
                <div className="col-md-1 col-sm-2">
                    <button className='btn btn-outline-danger w-xs-100 position-relative'
                            onClick={e => handleAddToCart(e)}
                    >
                        <i className="material-icons pt-1">add_shopping_cart</i>
                        {item.in_cart ?
                            <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                                <span className="visually-hidden">В корзине</span>
                            </span>
                            :
                            null
                        }
                    </button>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
        checkFavoriteItem,
        delFavoriteItem,
        updateItemQuantity,
        updateItemGroup,
        addToCart
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FavoriteProduct)
